/**
 * Delay composable
 */
export function useDelay(defaultDelay = 1000) {

  //Async delay helper
  const delay = (ms = defaultDelay) => new Promise(resolve => setTimeout(resolve, ms))

  //Return delay function
  return {
    delay,
  }
}
